/**
 * ie-downloader
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2017 Mediatel Limited.
 */

"use strict";

export default () => ({
    isIEDownloader() {
        return window.navigator.msSaveBlob;
    },

    isBase64(dataURI) {
        try {
            return (btoa(atob(dataURI)) === dataURI);
        } catch (err) {
            return false;
        }
    },

    dataURItoBlob(dataURI, type) {
        const byteString = this.isBase64(dataURI) ? atob(dataURI.split(",")[1]) : dataURI;
        const length = byteString.length;

        //write the bytes of the string to an ArrayBuffer
        const ab = new ArrayBuffer(length);

        const ia = new Uint8Array(ab);
        for (let i = 0; i < length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ab], { type: type});
    },

    download(dataURI, type, fileName) {
        navigator.msSaveBlob(
            this.dataURItoBlob(dataURI, type, fileName),
            fileName
        );
    }
});